import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { checkoutKeys } from '@/features/profile/hooks/useCheckout';
import { tokenKeys } from '@/features/profile/hooks/useTokens';

export default function CheckoutSuccessPage() {
  const queryClient = useQueryClient();

  // Invalidate token balance and subscription status to show updated values
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: tokenKeys.balance() });
    queryClient.invalidateQueries({ queryKey: tokenKeys.history() });
    queryClient.invalidateQueries({ queryKey: checkoutKeys.subscription() });
  }, [queryClient]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Success icon */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
          <svg
            className="w-10 h-10 text-green-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-white mb-4">Payment Successful!</h1>

        <p className="text-purple-300 mb-8">
          Thank you for your purchase! Your tokens will appear in your account momentarily.
        </p>

        <div className="space-y-3">
          <Link
            to="/profile"
            className="block w-full px-6 py-3 bg-purple-600 hover:bg-purple-500 text-white font-medium rounded-xl transition-colors"
          >
            View Your Profile
          </Link>

          <Link
            to="/"
            className="block w-full px-6 py-3 text-purple-300 hover:text-white transition-colors"
          >
            Continue Reading
          </Link>
        </div>
      </div>
    </div>
  );
}
